import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Roles, SupervisionNoteStatus } from '../constants';
import { areUserRolesIn } from '../helpers';

function useClientSupervisionEditable(checkLoading = true) {
  const { user } = useSelector((state: any) => state.auth);
  const { current: supervision, loading: clienSpLoading } = useSelector(
    (state: any) => state.clientSupervisions,
  );
  const [isEditable, setIsEditable] = useState<boolean>(false);

  useEffect(() => {
    if (!user) return;

    if (
      !supervision ||
      !areUserRolesIn(user?.roles, [Roles.Bcba]) ||
      (supervision?.provider && user?.email !== supervision?.provider.email) ||
      supervision?.status === SupervisionNoteStatus.Completed ||
      (checkLoading && clienSpLoading)
    ) {
      setIsEditable(false);
    } else {
      setIsEditable(true);
    }
  }, [user, supervision, clienSpLoading, checkLoading]);

  return isEditable;
}

export default useClientSupervisionEditable;
